import { mode } from '@chakra-ui/theme-tools';

/**
 * Panel backgrounds — OKLCH tints for status (light). Dark mode uses lower-lightness versions of the same hues.
 */
const PANEL_BG_OKLCH = {
  blue: {
    light: 'oklch(0.96 0.02 260)',
    dark: 'oklch(0.28 0.07 260)',
  },
  green: {
    light: 'oklch(0.97 0.04 165)',
    dark: 'oklch(0.30 0.09 165)',
  },
  orange: {
    light: 'oklch(0.97 0.04 85)',
    dark: 'oklch(0.30 0.09 85)',
  },
  red: {
    light: 'oklch(0.96 0.03 25)',
    dark: 'oklch(0.30 0.07 25)',
  },
} as const;

function panelBg(props: any, scheme: string) {
  const pal =
    PANEL_BG_OKLCH[scheme as keyof typeof PANEL_BG_OKLCH] ?? PANEL_BG_OKLCH.blue;
  return mode(pal.light, pal.dark)(props);
}

/**
 * Alert multi-part theme. Built-in variants (subtle, solid, left-accent, top-accent) remain available.
 *
 * Default variant is `panel` (OKLCH status tints). Toasts default to `panel` via `ChakraProvider` `toastOptions`.
 */
export const alertStyles = {
  components: {
    Alert: {
      defaultProps: {
        variant: 'panel',
      },
      baseStyle: {
        container: {
          borderRadius: '12px',
        },
      },
      variants: {
        panel: (props: any) => {
          const scheme = props.colorScheme ?? 'blue';
          const bg = panelBg(props, scheme);

          const fgStrong = mode('navy.900', 'white')(props);
          const fgMuted = mode('secondaryGray.700', 'whiteAlpha.900')(props);

          return {
            container: {
              bg,
              borderWidth: 0,
              boxShadow: mode(
                '0px 2px 10px rgba(112, 144, 176, 0.12)',
                '0px 2px 12px rgba(0, 0, 0, 0.45)',
              )(props),
            },
            icon: {
              color: fgStrong,
            },
            spinner: {
              color: fgStrong,
            },
            title: {
              color: fgStrong,
            },
            description: {
              color: fgMuted,
            },
          };
        },
      },
    },
  },
};
